import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class ContactCardApi extends ComponentAPI {
}
export default ContactCardApi;
//# sourceMappingURL=contact-card-api.js.map